<template>
    <div class="error-view" :class="{ 'is-embedded': embedded }">
        <NadiaOrb :size="64" :animated="false" />
        <h2 class="heading">Something went wrong on my side</h2>
        <p class="body-copy">Nothing you&rsquo;ve told me is lost &mdash; try again and I&rsquo;ll pick up where we left off.</p>
        <BaseButton theme="secondary" @click="emit('retry')">
            <i aria-hidden="true" class="bi bi-arrow-clockwise"></i>
            Try again
        </BaseButton>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";

import NadiaOrb from "./NadiaOrb.vue";

const emit = defineEmits<{ retry: [] }>();
const { embedded = false } = defineProps<{ embedded?: boolean }>();
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .error-view {
        @apply mx-auto flex max-w-md flex-1 flex-col items-center justify-center gap-4 px-6 pb-16 text-center;
    }

    .heading {
        @apply display-small-serif text-valence-grey-850;
    }

    .error-view.is-embedded .heading {
        @apply title-body-bold;
    }

    .body-copy {
        @apply body-small text-valence-grey-750;
    }
}
</style>
